import { BaseVariableControl } from './_base-control';



export class CheckboxControl extends BaseVariableControl {
}
